module.exports = __webpack_public_path__ + "img/ksj005.prt.956727c6.jpg";